import Buyers from "../views/client/buyers";
import Sellers from "../views/client/sellers";

import WorkIcon from "../assets/icons/work.svg";
import WorkHoverIcon from "../assets/icons/work-hover.svg";
import TeamIcon from "../assets/icons/team.svg";
import TeamHoverIcon from "../assets/icons/team-hover.svg";

const routesClients = [
    {
        path: "/sellers",
        name: "Vendedores",
        icon: WorkIcon,
        iconHover: WorkHoverIcon,
        layout: "/clients",
        component: Sellers,
        redirect: false,
    },

    {
        path: "/buyers",
        name: "Compradores",
        icon: TeamIcon,
        iconHover: TeamHoverIcon,
        layout: "/clients",
        component: Buyers,
        redirect: false,
    },
]

export default routesClients;